import React, { useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { Modal, Input, Button } from '../components'
import {http, hasViolations, createViolation, createViolations} from '../http'

const initialFormValues = {
  version: '',
  file: null,
}

export const FirmwareCreateRoute = props => {
  const { onCommit } = props
  const navigate = useNavigate()
  const [formValues, setFormValues] = useState(initialFormValues)
  const [violations, setViolations] = useState({})

  return (
    <Modal heading="Add firmware" onClose={() => navigate(-1)}>
      <div className="mt-4 ">
        <Input
          label="Version"
          type="text"
          error={violations['version']}
          onChange={fieldValue => handleChange('version', fieldValue)}
        />
      </div>
      <div className="mt-4 mb-8">
        <Input.File
          label="File"
          error={violations['file']}
          onChange={fileList => handleChange('file', fileList[0] || null)}
        />
      </div>
      <Button.Group>
        <Button.Outlined
          component={Link}
          to="/firmwares"
          text="Cancel"
        />
        <Button.Primary
          text="Save"
          onClick={handleCommit}
        />
      </Button.Group>
    </Modal>
  )

  function handleChange(name, value) {
    setFormValues(prev => ({ ...prev, [name]: value }))
  }

  function handleCommit() {
    http.upload('/crm.firmware.create', formValues).then(res => {
      if (hasViolations(res)) {
        setViolations(createViolations(res))
        return
      }

      navigate(-1)
      onCommit()
    })
  }
}